import { Post } from '../helpers';
import type { UserStatus } from '@/types/all-attendees.types';

export default function DownloadUsers({
  channel,
  projectUuid,
  statuses,
  signal,
}: {
  channel: number;
  projectUuid: string;
  statuses: UserStatus[];
  signal?: AbortSignal;
}) {
  return Post<Response>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/download-users`,
    body: { statuses },
    signal,
  });
}
